import http from "@/utils/http";

// 获取 标签列表
export const getTagList: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/tag/list',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};

// 获取 工具列表
export const getToolList: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/list',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};

// 获取 工具详情
export const getToolDetail: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/one',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};

// 获取 相似推荐
export const getToolSimilar: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/similar',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};

// 删除工具
export const deleteTool: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/delete',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};

// 编辑工具
export const editTool: (params: object) => Promise<any> = (params) => {
  return http({
    url: '/api/v1/aitools/update',
    method: 'post',
    errorHandler: true,
    data: params,
  });
};